(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Node)) return;

    const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
    const openDetails = document.querySelectorAll('details[data-auto-close-details][open]');
    if (!openDetails.length) return;

    for (const detailsElement of openDetails) {
      const closeModes = detailsElement.getAttribute('data-auto-close-details');
      if (!closeModes || !closeModes.includes(closingOn)) continue;
      if (!detailsElement.contains(event.target)) detailsElement.removeAttribute('open');
    }
  });
})();
